export const onlyNumbers = (e: any) => {
  // Allow control keys
  if (
    e.key === "Backspace" ||
    e.key === "Delete" ||
    e.key === "Tab" ||
    e.key === "ArrowLeft" ||
    e.key === "ArrowRight"
  ) {
    return;
  }
  // Allow digits 0–9
  if (e.key >= "0" && e.key <= "9") {
    return;
  }

  // Block everything else
  e.preventDefault();
};
